import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { CountryCode } from '@/store/ui';
import { countries } from '@/constants';
import { getCountryName } from '@/helpers';

@Component({
  name: 'CmgRewardsCountryMismatchModal',
})
export default class CmgRewardsCountryMismatchModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardsCountryMismatch.visible;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get siteCountry(): string {
    return getCountryName(this.$appStore.state.ui.countryProfile.countryCode, { useShortName: true });
  }

  get userProfileCountryCode(): string {
    return this.$appStore.state.customer.profile!.country || CountryCode.US;
  }

  get userProfileCountry(): string {
    return getCountryName(this.userProfileCountryCode.toLowerCase(), { useShortName: true });
  }

  redirectToUserCountry() {
    this.$services.ui.setCountryProfile(countries[this.userProfileCountryCode.toLowerCase()], true);
  }

  onClose(): void {
    this.$services.ui.setModalVisibility('rewardsCountryMismatch', false);
  }
}
